import { useState } from "react";
import { ChevronRight, Lock, User, Building2, Truck, Settings2 } from "lucide-react";
import LeftPanel from "../../components/ui/LeftPanel";
import Logo from "../../components/ui/Logo";

const ROLES = [
  {
    key: "resident",
    label: "Resident",
    desc: "Access your unit & confirm trash submission",
    I: User,
    a: { bg: "#f1f8e9", bd: "#aed581", ib: "#dcedc8", t: "#33691e" },
  },
  {
    key: "hoa",
    label: "HOA Admin",
    desc: "Desktop dashboard · Property management",
    I: Building2,
    a: { bg: "#e3f2fd", bd: "#90caf9", ib: "#bbdefb", t: "#1565c0" },
  },
  {
    key: "valet",
    label: "Valet",
    desc: "Mobile operational view · Status updates",
    I: Truck,
    a: { bg: "#fff3e0", bd: "#ffb74d", ib: "#ffe0b2", t: "#e65100" },
  },
  {
    key: "superadmin",
    label: "Super Admin",
    desc: "Full system control · All properties",
    I: Settings2,
    a: { bg: "#f3e5f5", bd: "#ce93d8", ib: "#e1bee7", t: "#6a1b9a" },
  },
];

function RoleCard({ r, onSelect, delay }) {
  const [hov, setHov] = useState(false);
  const RI = r.I;
  return (
    <button
      className={`rc fu ${delay}`}
      onClick={() => onSelect(r.key)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        width: "100%", textAlign: "left",
        background: hov ? r.a.bg : "var(--wh)",
        border: `1.5px solid ${hov ? r.a.bd : "var(--ln)"}`,
        borderRadius: 12, padding: "14px 15px",
        display: "flex", alignItems: "center", gap: 13,
        fontFamily: "'Outfit',sans-serif", cursor: "pointer",
        boxShadow: hov ? "0 5px 20px rgba(0,0,0,.07)" : "0 1px 3px rgba(0,0,0,.04)",
        minHeight: 64,
      }}
    >
      <div style={{
        width: 42, height: 42, borderRadius: 10, flexShrink: 0,
        background: hov ? r.a.ib : "var(--g50)",
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "background .2s",
      }}>
        <RI size={19} strokeWidth={1.7} color={hov ? r.a.t : "var(--g600)"} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 14.5, fontWeight: 600,
          color: hov ? r.a.t : "var(--ink)",
          marginBottom: 2, transition: "color .2s",
        }}>{r.label}</div>
        <div style={{ fontSize: 12.5, color: "var(--mut)", fontWeight: 400, lineHeight: 1.4 }}>
          {r.desc}
        </div>
      </div>
      <div style={{
        color: hov ? r.a.t : "var(--ln)",
        transition: "color .2s,transform .2s",
        transform: hov ? "translateX(3px)" : "none",
        flexShrink: 0,
      }}>
        <ChevronRight size={16} />
      </div>
    </button>
  );
}

export default function Landing({ onSelect }) {
  return (
    <div className="auth-shell">
      <LeftPanel role="landing" />
      <div className="auth-right">
        <div className="auth-form-wrap">

          {/* Mobile: logo at top */}
          <div className="mob-header" style={{ display: "flex" }}>
            <Logo compact />
          </div>

          <div className="fu" style={{ marginBottom: 28 }}>
            <div style={{
              fontSize: 10.5, fontWeight: 700, letterSpacing: "2.2px",
              textTransform: "uppercase", color: "var(--mut)", marginBottom: 9,
            }}>Welcome back</div>
            <h1 style={{
              fontFamily: "'Playfair Display',serif",
              fontSize: "clamp(22px,3.5vw,30px)", fontWeight: 500,
              color: "var(--ink)", marginBottom: 6, lineHeight: 1.22,
            }}>Sign in to your account</h1>
            <p style={{ fontSize: 13.5, color: "var(--mut)", fontWeight: 300 }}>
              Select your role to continue
            </p>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
            {ROLES.map((r, i) => (
              <RoleCard key={r.key} r={r} onSelect={onSelect} delay={`d${i + 1}`} />
            ))}
          </div>

          <div className="fu d5" style={{
            marginTop: 24, paddingTop: 20,
            borderTop: "1px solid var(--ln)",
            display: "flex", alignItems: "center", gap: 8,
          }}>
            <Lock size={12} strokeWidth={2} color="var(--mut)" />
            <span style={{ fontSize: 12, color: "var(--mut)" }}>
              All sessions are encrypted end-to-end
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}